// istanbul ignore file
// TODO: Add tests as part of DMD-4932
import Button from '@mui/material/Button';
import { useFormContext } from 'react-hook-form';

import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { useCreateBookingMutation } from 'reservations/form/queries/useCreateBookingMutation';

function AddToWaitlistButton() {
  const { handleIsLoading, handleHasLoaded } = useLoadingSpinner();
  const { handleSubmit } = useFormContext();

  const mutation = useCreateBookingMutation();

  const onSubmit = (data: Record<string, any>) => {
    handleIsLoading('Adding your party to the waitlist...');
    mutation.mutate(data);
  };

  return (
    <Button
      data-testid="add-to-waitlist-button"
      onClick={handleSubmit(onSubmit, handleHasLoaded)}
      size="fullWidth"
    >
      Confirm
    </Button>
  );
}

export default AddToWaitlistButton;
